import { useState, useRef } from "react"
import { useNavigate } from "react-router-dom"

import Style from "./style"
import show from "./asset/show.svg"
import hide from "./asset/hide.svg"
import Logo from "./asset/logo.svg"
import Apple from "./asset/apple.svg"
import Google from "./asset/google.svg"
import Kakao from "./asset/kakao.svg"

import FooterPage from "widget/FooterPage"

import DefaultInput from "shared/ui/DefaultInput"
import DefaultButton from "shared/ui/DefaultButton"

import usePostAccountLogin from "entity/auth/usePostAuthLogin"
import useGetAuthSns from "entity/auth/useGetAuthSns"

const Login = () => {
    const navigate = useNavigate()
    const idRef = useRef()
    const pwRef = useRef()

    const [isPasswordShow, setIsPasswordShow] = useState(false)

    const [postLogin] = usePostAccountLogin(idRef, pwRef)
    const [getRedirect] = useGetAuthSns()

    return (
        <FooterPage>
            <Style.Wrapper>
                <Style.LogoImg src={Logo} onClick={() => navigate("/")} />

                <Style.LoginForm>
                    <DefaultInput placeholder="아이디" inputRef={idRef} />
                    <DefaultInput type={isPasswordShow ? "text" : "password"} placeholder="비밀번호" inputRef={pwRef}>
                        <Style.ShowButton onClick={() => setIsPasswordShow(state => !state)}>
                            <img src={isPasswordShow ? hide : show} />
                        </Style.ShowButton>
                    </DefaultInput>
                    <Style.LoginButtonDiv>
                        <DefaultButton clickEvent={postLogin}>로그인</DefaultButton>
                    </Style.LoginButtonDiv>
                </Style.LoginForm>

                <Style.ControlDiv>
                    <Style.ButtonDiv>
                        <button onClick={() => navigate("/find/id")}>아이디 찾기</button>
                        |
                        <button onClick={() => navigate("/find/password")}>비밀번호 찾기</button>
                    </Style.ButtonDiv>
                    <Style.SignupButton onClick={() => navigate("/signup")}>회원가입</Style.SignupButton>
                </Style.ControlDiv>

                <Style.ControlDiv>
                    <Style.SnsLabel>소셜 로그인</Style.SnsLabel>
                    <Style.SnsSignupDiv>
                        <Style.SnsButton $kakao onClick={() => getRedirect("kakao")}><img src={Kakao} /></Style.SnsButton>
                        <Style.SnsButton $google onClick={() => getRedirect("google")}><img src={Google} /></Style.SnsButton>
                        <Style.SnsButton $apple onClick={() => getRedirect("apple")}><img src={Apple} /></Style.SnsButton>
                    </Style.SnsSignupDiv>
                </Style.ControlDiv>

            </Style.Wrapper >
        </FooterPage>
    )
}

export default Login